<template>
    <div id="app">
        <div class="drag-box allow-drag"></div>
        <router-view></router-view>
    </div>
</template>

<script>
  export default {
    name: 'netdisc',
    data() {
      return {
        currentUser: '',
        currentToken: '',
        webOpenUrl: '',
      }
    }
  }
</script>

<style scoped>
    #app {
        position: relative;
    }


    .drag-box {
        z-index: -1;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        background: black;
        opacity: 0;
        width: 100vw;
        height: 30px;
    }
</style>
